<template>
    <td-login @loginSucess="loginSucess"></td-login>
</template>
<script>
export default {
    methods: {
        /* 登录成功后调用 */
        loginSucess() {}
    }
};
</script>
